// extracted by mini-css-extract-plugin
module.exports = {"container":"Indicators_container__11dKS","value":"Indicators_value__3rGg2","icon":"Indicators_icon__bOoO0","label":"Indicators_label__16nV8","info":"Indicators_info__3-wlA"};